import comp from "./AddonsDatagrid";
export default comp;
